import { editMenu, addMenu } from './request';
export default {
  name: 'customerModel',
  props: {
    currentRow: [Object, null],
    dialogVisible: Boolean
  },
  data() {
    return {
      roleFrom: {
        parentId: 0,
        position: 1,
        name: '',
        icon: '',
        sort: '0',
        isShow: '',
        isOpen: '',
        remark: ''
      },
      loading: false
    };
  },
  created() {
    if (this.currentRow.id) {
      this.roleFrom = this.currentRow;
    } else if (this.currentRow.isOpen != null) {
      this.roleFrom.isOpen = this.currentRow.isOpen;
    }
  },
  computed: {
    roleRule() {
      return {
        icon: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('icon')
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('菜单名称')
        }],
        isShow: [{
          required: true,
          message: this.$t('请选择') + this.$t('状态'),
          trigger: 'change'
        }],
        isOpen: [{
          required: true,
          message: this.$t('请选择') + this.$t('客户是否可见'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    handleSure() {
      this.$refs.roleFrom.validate(valid => {
        this.loading = true;
        if (valid) {
          if (this.currentRow.id) {
            //编辑
            this.roleFrom.menuId = this.currentRow.id;
            editMenu(this.roleFrom).then(() => {
              this.$message.success(this.$t('修改成功'));
              this.loading = false;
              this.$emit('ok');
              this.$emit('cancel');
            });
          } else {
            //新增
            addMenu(this.roleFrom).then(() => {
              this.$message.success(this.$t('添加成功'));
              this.loading = false;
              this.$emit('ok');
              this.$emit('cancel');
            });
          }
        } else {
          this.loading = false;
        }
      });
    }
  }
};